import { useEffect } from "react";
import { Link } from "react-router-dom";
import { setSEO } from "../lib/data/seo";
import { CITIES } from "../lib/data/cities";
import { SERVICES } from "../lib/data/services";
import { REGIONS } from "../lib/data/regions";
import { BLOG_POSTS } from "../lib/data/blog";

export default function Sitemap() {
  useEffect(() => {
    setSEO({
      title: "Sitemap — British Columbia Security Services",
      description: "Full sitemap of British Columbia Security Services pages including all cities, services, and city × service SEO landing pages.",
      canonical: `${window.location.origin}/sitemap`,
    });
  }, []);

  return (
    <div className="pt-24 pb-24 bg-[#F4F4F0] min-h-screen">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 pt-16">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323]">
          Sitemap
        </div>
        <h1 className="mt-4 font-display text-5xl md:text-7xl tracking-tighter leading-[0.95] text-[#060913]">
          Every page.
        </h1>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <h2 className="font-display text-2xl text-[#D92323] mb-4">Services</h2>
            <ul className="space-y-2">
              {SERVICES.map((s) => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-[#D92323]">{s.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-display text-2xl text-[#D92323] mb-4">Regions</h2>
            <ul className="space-y-2">
              {REGIONS.map((r) => (
                <li key={r.slug}><Link to={`/regions/${r.slug}`} className="hover:text-[#D92323]">{r.name}</Link></li>
              ))}
            </ul>
            <h2 className="font-display text-2xl text-[#D92323] mt-8 mb-4">Journal</h2>
            <ul className="space-y-2">
              {BLOG_POSTS.map((p) => (
                <li key={p.slug}><Link to={`/blog/${p.slug}`} className="hover:text-[#D92323]">{p.title}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h2 className="font-display text-2xl text-[#D92323] mb-4">Cities</h2>
            <ul className="space-y-1 columns-1 sm:columns-2 lg:columns-3">
              {CITIES.map((c) => (
                <li key={c.slug}><Link to={`/cities/${c.slug}`} className="hover:text-[#D92323]">{c.name}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16">
          <h2 className="font-display text-3xl text-[#060913] mb-6">Service × City Landing Pages</h2>
          <p className="text-[#5C5F66] mb-6 max-w-3xl">
            SEO landing pages combining each service with each city. {SERVICES.length * CITIES.length}+ pages total.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-1 max-h-[600px] overflow-y-auto pr-4 border border-black/10 p-4">
            {SERVICES.flatMap((s) =>
              CITIES.map((c) => (
                <Link
                  key={`${s.slug}-${c.slug}`}
                  to={`/${s.slug}-${c.slug}`}
                  className="text-xs font-mono uppercase tracking-[0.14em] py-0.5 text-[#060913]/70 hover:text-[#D92323]"
                >
                  {s.name} · {c.name}
                </Link>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
